import { render, staticRenderFns } from "./articles.html?vue&type=template&id=4f99b042&scoped=true&external"
import script from "./articles.js?vue&type=script&lang=js&external"
export * from "./articles.js?vue&type=script&lang=js&external"
import style0 from "./articles.scss?vue&type=style&index=0&id=4f99b042&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f99b042",
  null
  
)

export default component.exports